export const Field = ({ label, children, className = "" }) => (
  <label className={`block ${className}`}>
    <span className="mb-1.5 block font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-400">{label}</span>
    {children}
  </label>
);

export const inputCls =
  "w-full rounded-lg border border-white/10 bg-[#0B0B0E] px-3 py-2.5 text-sm text-white outline-none transition-colors placeholder:text-zinc-600 focus:border-[#CCFF00]";
